const RoutingList = {
  index: "/",
  patientAdmission: {
    index: "/patient",
    create: "/patient/admission",
    edit: "/patient/admission/edit",
  },
  referral: {
    index: "/referral",
    create: "/referral/add",
    edit: "/referral/edit",
  },
  login: {
    index: "/login",
    forgetPassword: "/forget-password",
    verify_email: "/login/verify-email",
    updatePassword: "/update-password",
  },
  bedStatus: {
    index: "/bed-status",
  },
  disease: {
    index: "/treatment",
  },
  district: {
    index: "/district",
  },
  department: {
    index: "/department",
    create: "/department/add",
    edit: "/department/edit",
  },
  user: {
    index: "/user",
    create: "/user/add",
    edit: "/user/edit",
  },
  settings: {
    index: "/settings",
    edit: "/settings/edit",
    change_password: "/settings/change-password",
  },
  verify: {
    verifyLink: "/verify-link",
    changePasswordAfterVerify: "/verify/change-password",
  },
  page_not_found: "/*",
};

export default RoutingList;
